<template >
  <div class="footSubmit">
    <el-button
      style="float: right; margin-right: 30px"
      size="small"
      type="primary"
      v-preventReClick
      @click="saveEdit()"
      >{{ rightTitle }}</el-button
    >
    <el-button
      style="float: right; margin-right: 15px"
      size="small"
      @click="toCancel()"
      >{{ leftTitle }}</el-button
    >
  </div>
</template>

<script>
export default {
  props: {
    leftTitle: {
      type: String,
      default: "取消",
    },
    rightTitle: {
      type: String,
      default: "提交",
    },
    nextTitle: {
      type: String,
      default: "下一步",
    },
  },
  methods: {
    saveEdit() {
      this.$emit("saveEdit");
    },
    // 取消
    toCancel() {
      if (this.leftTitle == "取消") {
        this.$router.back(-1);
      } else {
        this.$emit("leftFunction");
      }
    },

    submit(form) {
      if (this.$route.query.id) {
        this.$emit("updateInfo", form);
      } else {
        this.$emit("addInfo", form);
      }
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/layout/footLayout.vue